(function () {
  'use strict';

  /* @ngdoc object
   * @name crewDownloads
   * @description
   *
   */
  angular
    .module('crewDownloads', [
      'ui.router'
    ]);
}());
